import CountyLandingPage from "../components/CountyLandingPage";

const data = {
  slug: "san-diego",
  region: "San Diego",
  metaTitle: "San Diego ADU Permit Toolkit",
  h1Prefix: "San Diego ADU permits,",
  h1Accent: "with paperwork that doesn't bounce.",
  subtitle:
    "Pre-built for San Diego's Development Services Department workflow — a CALGreen waste plan, Title 24 notes, and an AI-generated compliance cover memo specifically referencing local C&D recycling facilities and SD's permit-streamlining program.",
  heroStats: [
    { value: "1,000s", label: "of SD ADUs permitted under streamlining" },
    { value: "65%", label: "minimum CALGreen diversion (SDMC §142)" },
    { value: "<10 min", label: "wizard to permit-ready package" },
  ],
  localRules: [
    {
      title: "City of San Diego ADU bonus program",
      body: "San Diego allows up to two ADUs (one ADU + one Junior ADU) on most single-family lots. The waste plan must reference the bonus program path so reviewers route the application correctly.",
    },
    {
      title: "Development Services Department (DSD) submittal",
      body: "DSD requires CALGreen documentation uploaded with the building permit submittal. Our memo's call-to-action explicitly addresses DSD plan checkers.",
    },
    {
      title: "EDCO and Republic Services recycling routes",
      body: "San Diego's main C&D haulers (EDCO, Republic Services) are pre-populated as facility options — and concrete/clean-wood diversion math is calibrated to local infrastructure.",
    },
    {
      title: "Climate Action Plan (CAP) alignment",
      body: "San Diego's CAP encourages high-diversion construction. Our memo highlights how the project's diversion strategy aligns with both CALGreen and the city's CAP — a nice signal for reviewers.",
    },
  ],
  painPoints: [
    "Generic waste plans missing the DSD-specific call-out — sent back for clarification.",
    "Underestimating drywall waste in Mira Mesa / Eastlake builds (limited recycling routes).",
    "Forgetting EDCO weight-ticket format on the Final Verification Report.",
    "Skipping the Climate Action Plan reference — minor but reviewers love seeing it.",
    "Submitting without a subcontractor acknowledgement page.",
  ],
  faqs: [
    {
      q: "Does San Diego require a CWMP for an ADU?",
      a: "Yes. SDMC §142 and CALGreen §5.408 require a Construction Waste Management Plan for ADU permits with a 65% minimum diversion. Junior ADUs converted from existing space follow a slightly different path — our wizard accommodates both.",
    },
    {
      q: "Is this valid for unincorporated San Diego County?",
      a: "Yes. Both City of San Diego and County jurisdictions are supported, with appropriate references to either DSD or the County PDS in the AI memo.",
    },
    {
      q: "What about the SD ADU bonus program?",
      a: "When you select 'two-unit ADU' or 'JADU + ADU' in the wizard, the plan and memo automatically reference the SD bonus program path so plan checkers route the application correctly.",
    },
    {
      q: "How does pricing work?",
      a: "A one-off CWMP is $59. Bundle (CWMP + Final Verification + unlimited AI memos) and a monthly subscription are also available for high-volume contractors. Admin sets live pricing — current rates appear on the pricing section above.",
    },
  ],
};

const CountySanDiegoPage = () => <CountyLandingPage data={data} />;
export default CountySanDiegoPage;
